import { useFetcher } from '@remix-run/react'
import { Loading } from '~/design-system/primitives'
import { Block, Delete } from '~/icons'
import type { Product } from '~/type/Cart'

export type ProductItemProps = {
  item: Product
  description: string
}

export default function UnavailableTag({ item, description }: ProductItemProps) {
  const fetcher = useFetcher()

  return (
    <div className="flex self-center items-center w-32">
      <div className="flex self-center justify-around items-center bg-gray-20 w-28 rounded-sm p-0.5">
        <Block className="fill-gray-100" />
        {description}
      </div>
      <fetcher.Form action="/checkout/cart" className="flex" method="post">
        <input name="actionType" type="hidden" value="changeQuantity" />
        <input name="itemId" type="hidden" value={item.id} />
        <input name="quantity" type="hidden" value={0} />
        <button aria-label="Remover produto" className="mx-1" type="submit">
          <Delete className="fill-gray-100" />
        </button>
        {fetcher.state != 'idle' && <Loading />}
      </fetcher.Form>
    </div>
  )
}
